import { collection, addDoc, serverTimestamp, getDocs, query, where } from "firebase/firestore";
import { db } from "./config";

export const addDocument = (collectionName: string, data: any) => {
  return addDoc(collection(db, collectionName), {
    ...data,
    createAt: serverTimestamp(),
  });
};

export const getFileCount = async (userId: string) => {
  let size = 1000;
  const q = query(collection(db, "files"), where("uid", "==", userId));
  const snapshot = await getDocs(q);
  size = snapshot.size;
  return size;
};
